// extracted by mini-css-extract-plugin
module.exports = {"title":"SettingsHeadline_title__19gp_","firstline":"SettingsHeadline_firstline__fiUqJ","nameInput":"SettingsHeadline_nameInput__2j1Rq","form":"SettingsHeadline_form__JndN1"};